import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/preferences/roles/$roleId/')({
  component: () => null,
})
